// src/service/context/tokencontent.tsx
import React, { createContext } from 'react';

interface TokenContextType {
  token: string | null;
  setToken: (token: string | null) => void;
}

export const TokenContext = createContext<TokenContextType | undefined>(undefined);


